import { observer } from "mobx-react-lite";
import { useMapStore, useViewSettingsStore } from '../..';
import useNavigateToCountyInsights from '../../hooks/useNavigateToCountyInsights';
import useNavigateToProperty from '../../hooks/useNavigateToProperty';
import useOpenSelectedItem from '../../hooks/useOpenSelectedItem';
import IGeoCoordinate from '../../interfaces/IGeoCoordinate';
import AddressIcon from '../icons/AddressIcon';
import styles from '../InfoWithIconAndNavigation.module.css';
import AddresInfo, { IAddressInfoProps } from "./AddressInfo";

const typesAsPlace = ["place", "district", "locality", "neighborhood", "street"];

function AddresInfoWithIconAndNavigation({ address, types, coordinate, className, onClick, index }: IAddressInfoWithIconAndNavigationProps) {
    const navigateToProperty = useNavigateToProperty();
    const navigateToCountyInsights = useNavigateToCountyInsights();
    const mapStore = useMapStore();
    const viewSettingsStore = useViewSettingsStore();

    const click = () => {
        onClick && onClick();
        if (types.includes("district") && !viewSettingsStore.isMobile) {
            navigateToCountyInsights(address, coordinate);
        } else if (types.some(t => typesAsPlace.includes(t))) {
            mapStore.setViewState({
                latitude: coordinate.latitude,
                longitude: coordinate.longitude,
                zoom: 13,
            });
        } else {
            navigateToProperty(coordinate.longitude, coordinate.latitude);
        }
    };

    useOpenSelectedItem(index, click);

    return (
        <div className={[styles.container, className].join(" ")} onClick={click}>
            <AddressIcon className={styles.icon} />
            <AddresInfo
                address={address}
            />
        </div>
    );
}

interface IAddressInfoWithIconAndNavigationProps extends IAddressInfoProps {
    types: string[];
    coordinate: IGeoCoordinate;
    index?: number;
}

export default observer(AddresInfoWithIconAndNavigation);